import Joi from 'joi';

/**
 * Schema for existing filebox record validation.
 */
export const updateFileboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
